module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"es","langs":["es","en"]}}}},"pathContext":{"slug":"/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 771
// module chunks = 142629428675168